import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './shared/guards/login/login.gaurd';
import { PermissionGuard } from './shared/guards/permission/permission.guard';
import { GlobalAdminGuard } from './shared/guards/global-admin/global-admin.guard';
import { PermissionDefinitions } from './services/authorization/permission-definitions';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/account/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'externalLogin',
    loadChildren: () => import('./components/externalLogin/external-login.module').then(m => m.ExternalLoginModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/account/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'practitioner-onboarding',
    loadChildren: () => import('./pages/account/pre-registration/pre-registration.module').then(m => m.PreRegistrationPageModule)
  },
  {
    path: 'practitioner-onboarding/:preRegistrationId',
    loadChildren: () => import('./pages/account/pre-registration/pre-registration.module').then(m => m.PreRegistrationPageModule)
  },
  {
    path: 'clinic-group-link/:requestId',
    loadChildren: () => import('./pages/account/clinic-group-link/clinic-group-link.module').then(m => m.ClinicGroupLinkPageModule)
  },
  {
    path: 'forget-password',
    loadChildren: () => import('./pages/account/forget-password/forget-password.module').then(m => m.ForgetPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/account/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    canLoad: [LoginGuard, PermissionGuard],
    path: 'account/profile',
    data: { permissions: [PermissionDefinitions.ACCOUNT_PROFILE_PAGE_VIEW] },
    loadChildren: () => import('./pages/account/profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'welcome',
    canLoad: [LoginGuard],
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule)
  },
  {
    canLoad: [LoginGuard, PermissionGuard],
    path: 'clinic-group',
    data: { permissions: [PermissionDefinitions.CLINIC_GROUP_DETAIL_FORM_VIEW] },
    loadChildren: () => import('./pages/clinic-group/clinic-group.module').then(m => m.ClinicGroupPageModule)
  },
  {
    canLoad: [LoginGuard, GlobalAdminGuard],
    path: 'roles',
    loadChildren: () => import('./pages/roles/roles.module').then(m => m.RolesPageModule)
  },
  {
    path: 'anatomy',
    canLoad: [LoginGuard, GlobalAdminGuard],
    loadChildren: () => import('./pages/anatomy/anatomy.module').then(m => m.AnatomyPageModule)
  },
  {
    path: 'protocol/:id',
    canLoad: [LoginGuard, GlobalAdminGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/protocol/protocol.module').then(m => m.ProtocolPageModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'welcome',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }